import UniversalWebView from '@/components/UniversalWebView'
import { getAuthToken } from '@/lib/api/authToken'
import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import { useAppDispatch } from '@/redux/store'
import { router, useLocalSearchParams } from 'expo-router'
import { get } from 'lodash-es'
import { useCallback, useMemo } from 'react'

export default function PayResult() {
  const dispatch = useAppDispatch()
  const searchParams = useLocalSearchParams<{ order?: string; result?: string }>()

  const uri = useMemo(() => {
    const token = getAuthToken()
    const baseUrl = `${process.env.EXPO_PUBLIC_NEXT_BASE_URL}/m/payment/pay_result?m_t=${token}&embedded=nextapp`

    let url = baseUrl
    if (searchParams.order) {
      url += `&order=${searchParams.order}`
    }
    if (searchParams.result) {
      url += `&result=${searchParams.result}`
    }

    return url
  }, [searchParams.order, searchParams.result])

  const handleMessage = useCallback(
    (data: { event: string; details: unknown }) => {
      if (data.event === 'PAY_RESULT') {
        const status = get(data.details, 'status')
        if (status === 'success') {
          dispatch(fetchCurrentUserThunk())
          dispatch(getUsageAndBalanceThunk())
        }

        // Profile is pushed onto the system stack, so return to it rather than pushing another
        router.dismissTo('/profile')
      }
    },
    [dispatch]
  )

  return (
    <UniversalWebView
      source={{ uri }}
      style={{ backgroundColor: '#f3f4f6' }}
      onMessage={handleMessage}
      className="flex-1"
    />
  )
}
